import classcat from "classcat";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { HttpHeaderNames } from "@touchtech/web-api-client";
import { TenantIdContext } from "@touchtech/web-tenant-id-provider";

import { Logo } from "@is/components/Logo";
import { LocalStorageKeys, ROUTES, TranslationContext } from "@is/constants";
import { usePageParams, useProcessPendingEvents } from "@is/hooks";
import useSavePageUrl from "@is/hooks/useSavePageUrl";
import { LocalStorageService } from "@is/services";
import { api } from "@is/services/api";

import css from "./WelcomeView.module.css";

const WelcomeView = () => {
  const { t } = useTranslation(TranslationContext.DeviceRegistration);
  const { tenantId } = usePageParams();
  const [, setTenant] = useContext(TenantIdContext);

  useSavePageUrl();

  useEffect(() => {
    if (typeof tenantId !== "undefined") {
      LocalStorageService.setItem(LocalStorageKeys.TenantId, tenantId);
      api.setHeader(HttpHeaderNames.TENANT_ID, tenantId);
      setTenant(tenantId);
    }
  }, [tenantId, setTenant]);

  useProcessPendingEvents();

  return (
    <div className={css.container}>
      <div className={classcat(["text-display-9xl", css.title])}>
        {t("Welcome!")}
      </div>
      <Link to={ROUTES.Registration}>
        <div className={classcat(["text-headline-2xl", css.link])}>
          {t("touch to start setup")}
        </div>
      </Link>
      <Logo className={css.footer} />
    </div>
  );
};

export default WelcomeView;
